import { KendoBaseComponent, KendoBaseDatasourceComponent, KendoSharedMethods } from '@progress/kendo-base-components-vue-wrapper'
import ContextMenuProps from './ContextMenuProps'

import Animation from './Animation'
import Scrollable from '../Common/Scrollable'

export default {
    render (h) {
        return h('ul',this.$slots.default)
    },
    props: ContextMenuProps,
    mixins: [
        KendoBaseComponent,
        KendoBaseDatasourceComponent,
        KendoSharedMethods,
        Animation,
        Scrollable
    ],
    mounted() {
        this._resolveChildren()

        kendo.jQuery(this.$el).kendoContextMenu(this.widgetOptions)

        this.$emit('kendowidgetready', this.kendoWidget())
    },
    methods: {
        kendoWidget() {
            return kendo.jQuery(this.$el).getKendoContextMenu()
        },
        _resolveChildren() {
            if(this.$options.propsData && !this.$options.propsData['dataSource'] && this.$slots.default){
                var items = this.resolveInnerTags('kendo-menu-item')

                if(items.length) {
                    this.widgetOptions['dataSource'] = items
                }
            }
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-layout-vue-wrapper/src/KendoContextMenu/KendoContextMenuMixin.js